import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal, Card, FlexView, Button } from 'components/common'
import { Input, Select, TextArea } from 'components/form'
import styled from 'styled-components'
import { TransportContext } from 'stores/ManagementTransportStore'
import { UserContext } from 'stores/UserStore'

const Title = styled.h1`
    color: #000;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
`

const Label = styled.div`
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
	margin: 0px;
	padding: 0px;
`
const ReportDaily = ({ isOpen, onOutsideClick, title, status }) => {
	const { t } = useTranslation()
	const [date, setDate] = useState('')
	const [reason, setReason] = useState('')
	const [other, setOther] = useState('')
	const { changeStatus, resultInformation, solicitacao } = useContext(TransportContext)
	const { currentUser } = useContext(UserContext)

	useEffect(() => {
		setDate('')
		setReason('')
		setOther('')
	}, [onOutsideClick])

	const reasons = [
		{ label: "MPPL", value: "MPPL" },
		{ label: "MPPC", value: "MPPC" },
		{ label: "FNE", value: "FNE" },
		{ label: "EIP", value: "EIP" },
		{ label: "DDP", value: "DDP" },
		{ label: "FENF", value: "FENF" },
		{ label: "AC", value: "AC" },
		{ label: "ARM", value: "ARM" },
		{ label: "IP", value: "IP" },
		{ label: "NFI", value: "NFI" },
		{ label: "AEC", value: "AEC" },
		{ label: "IL", value: "IL" },
		{ label: "OUTRO", value: "OUTRO" }

	]


	const send = async () => {
		let payload = {
			status_from: status,
			user_id: currentUser.id,
			user_name: currentUser.name,
			date: new Date(),
			supplier_transport_request_id: resultInformation.id,
			transport_id: solicitacao,
			status_to: status,
			description: `${t(`transport.${title}`)} - ${reason}`,
			shippingCompany: resultInformation.shippingCompany
		}

		await changeStatus(payload)
		setDate('')
		setReason('')
		setOther('')
		onOutsideClick()
	}


	const checkDisable = () => {
		if (reason === '' || date === '') {
			return true
		} else if ((reason === "OUTRO" && other === '' ) || date === '' ) {
			return true
		} else {
			return false
		}
	}

	return <Modal isOpen={isOpen} onOutsideClick={onOutsideClick}>
		<Card width="20%">
			<Title>{t(`transport.${title}`)}</Title>
			<Input width="100%" type='date' label={t('transport.dailyDate')} value={date} onChange={(e) => setDate(e.target.value)} />
			<Select width="100%" label={t('transport.selectReason')} placeholder={t('transport.options')} options={reasons} value={reason} onChange={(e) => { setReason(e) }} style={{ minHeigth: '44px', heigth: '50px' }} />
			{reason === "OUTRO" ?
				<>
					<Label>{t('transport.otherReason')}</Label>
					<TextArea width='100%' style={{ margin: '0px' }} value={other} onChange={(e) => { setOther(e.target.value) }} />
				</>
				: null
			}
			<FlexView width="100%" flexDirection="row" alignItems="center" justifyContent="flex-end" style={{ columnGap: '5%' }}>
				<Button onClick={() => { onOutsideClick() }}>
					{t('transport.cancel')}
				</Button>
				<Button backgroundColor='primary' color='white' onClick={() => { send() }} disabled={checkDisable()}>
					{t(`transport.send`)}
				</Button>
			</FlexView>
		</Card>
	</Modal>
}

export default ReportDaily
